import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/lead-gen/")({
    beforeLoad: () => {
        throw redirect({ to: "/sales/leads", replace: true });
    },
});
